<template>
  <!-- begin app-header -->
  <header class="app-header top-bar">
    <!-- begin navbar -->
    <nav class="navbar navbar-expand-md">
      <!-- begin navbar-header -->
      <div class="navbar-header d-flex align-items-center">
        <a href="javascript:void:(0)" class="mobile-toggle">
          <i class="ti ti-align-right"></i>
        </a>
        <a class="navbar-brand">
          <svg width="150" height="127" viewBox="0 0 589 127" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_57_219)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M120 46.25L60 0L0 46.25L60 92.5L75.0397 80.9069L60.0394 69.3442L90.0394 46.2192L105.04 57.7819L120 46.25ZM89.9804 46.2344L59.9804 23.1094L29.9804 46.2344L59.9804 69.3594L89.9804 46.2344Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 80.0938L60 126.344L120 80.0938L60 33.8438L44.9604 45.4369L59.9606 56.9995L29.9606 80.1246L14.9603 68.5618L0 80.0938ZM30.0196 80.1093L60.0196 103.234L90.0196 80.1093L60.0196 56.9844L30.0196 80.1093Z" fill="#42A4D9"/>
            <path d="M193.944 37.2896C193.475 38.2283 192.92 38.8896 192.28 39.2736C191.683 39.6576 190.957 39.8496 190.104 39.8496C189.251 39.8496 188.291 39.5296 187.224 38.8896C186.157 38.2069 184.899 37.4603 183.448 36.6496C181.997 35.8389 180.291 35.1136 178.328 34.4736C176.408 33.7909 174.125 33.4496 171.48 33.4496C169.091 33.4496 167 33.7483 165.208 34.3456C163.459 34.9003 161.965 35.6896 160.728 36.7136C159.533 37.7376 158.637 38.9749 158.04 40.4256C157.443 41.8336 157.144 43.3909 157.144 45.0976C157.144 47.2736 157.741 49.0869 158.936 50.5376C160.173 51.9883 161.795 53.2256 163.8 54.2496C165.805 55.2736 168.088 56.1909 170.648 57.0016C173.208 57.8123 175.811 58.6869 178.456 59.6256C181.144 60.5216 183.768 61.5883 186.328 62.8256C188.888 64.0203 191.171 65.5563 193.176 67.4336C195.181 69.2683 196.781 71.5296 197.976 74.2176C199.213 76.9056 199.832 80.1696 199.832 84.0096C199.832 88.1909 199.107 92.1163 197.656 95.7856C196.248 99.4123 194.157 102.591 191.384 105.322C188.653 108.01 185.304 110.143 181.336 111.722C177.368 113.258 172.824 114.026 167.704 114.026C164.76 114.026 161.859 113.727 159 113.13C156.141 112.575 153.389 111.765 150.744 110.698C148.141 109.631 145.688 108.351 143.384 106.858C141.123 105.365 139.096 103.701 137.304 101.866L142.296 93.6096C142.765 93.0123 143.32 92.5216 143.96 92.1376C144.643 91.7109 145.389 91.4976 146.2 91.4976C147.267 91.4976 148.419 91.9456 149.656 92.8416C150.893 93.6949 152.344 94.6549 154.008 95.7216C155.715 96.7883 157.699 97.7696 159.96 98.6656C162.264 99.5189 165.016 99.9456 168.216 99.9456C173.123 99.9456 176.92 98.7936 179.608 96.4896C182.296 94.1429 183.64 90.7936 183.64 86.4416C183.64 84.0096 183.021 82.0256 181.784 80.4896C180.589 78.9536 178.989 77.6736 176.984 76.6496C174.979 75.5829 172.696 74.6869 170.136 73.9616C167.576 73.2363 164.973 72.4469 162.328 71.5936C159.683 70.7403 157.08 69.7163 154.52 68.5216C151.96 67.3269 149.677 65.7696 147.672 63.8496C145.667 61.9296 144.045 59.5403 142.808 56.6816C141.613 53.7803 141.016 50.2176 141.016 45.9936C141.016 42.6229 141.677 39.3376 143 36.1376C144.365 32.9376 146.328 30.1003 148.888 27.6256C151.491 25.1509 154.669 23.1669 158.424 21.6736C162.179 20.1803 166.467 19.4336 171.288 19.4336C176.749 19.4336 181.784 20.2869 186.392 21.9936C191 23.7003 194.925 26.0896 198.168 29.1616L193.944 37.2896ZM295.017 99.1136C298.345 99.1136 301.31 98.5589 303.913 97.4496C306.558 96.3403 308.777 94.7829 310.569 92.7776C312.404 90.7723 313.79 88.3403 314.729 85.4816C315.71 82.6229 316.201 79.4229 316.201 75.8816V20.4576H333.417V75.8816C333.417 81.3856 332.521 86.4843 330.729 91.1776C328.98 95.8283 326.441 99.8603 323.113 103.274C319.785 106.645 315.753 109.29 311.017 111.21C306.281 113.087 300.948 114.026 295.017 114.026C289.086 114.026 283.753 113.087 279.017 111.21C274.281 109.29 270.249 106.645 266.921 103.274C263.636 99.8603 261.097 95.8283 259.305 91.1776C257.556 86.4843 256.681 81.3856 256.681 75.8816V20.4576H273.897V75.8176C273.897 79.3589 274.366 82.5589 275.305 85.4176C276.286 88.2763 277.673 90.7296 279.465 92.7776C281.257 94.7829 283.454 96.3403 286.057 97.4496C288.702 98.5589 291.689 99.1136 295.017 99.1136ZM460.91 20.4576V34.6016H433.07V113.002H415.854V34.6016H387.886V20.4576H460.91ZM588.588 113.002H575.276C573.783 113.002 572.545 112.639 571.564 111.914C570.625 111.146 569.943 110.207 569.516 109.098L562.604 90.2176H524.268L517.356 109.098C517.015 110.079 516.332 110.975 515.308 111.786C514.327 112.597 513.111 113.002 511.66 113.002H498.284L534.636 20.4576H552.236L588.588 113.002ZM528.684 78.0576H558.188L546.924 47.2736C546.412 45.9083 545.836 44.3083 545.196 42.4736C544.599 40.5963 544.001 38.5696 543.404 36.3936C542.807 38.5696 542.209 40.5963 541.612 42.4736C541.057 44.3509 540.503 45.9936 539.948 47.4016L528.684 78.0576Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_57_219">
            <rect width="589" height="127" fill="white"/>
            </clipPath>
            </defs>
          </svg>

        </a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="ti ti-align-left"></i>
      </button>
      <!-- end navbar-header -->
      <!-- begin navigation -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="navigation d-flex">
          <ul class="navbar-nav nav-left">
            <li class="nav-item">
              <a href="javascript:void(0)" class="nav-link sidebar-toggle">
                <i class="ti ti-align-right"></i>
              </a>
            </li>
     
            <li class="nav-item full-screen d-none d-lg-block" id="btnFullscreen">
              <a href="javascript:void(0)" class="nav-link expand">
                <i class="icon-size-fullscreen"></i>
              </a>
            </li>
          </ul>
          <ul class="navbar-nav nav-right ml-auto">
         
         
           
            <li class="nav-item dropdown user-profile">
              <a
                href="javascript:void(0)"
                class="nav-link dropdown-toggle"
                id="navbarDropdown4"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
              <i class="zmdi zmdi-user text-dark"></i>
                <span class="bg-success user-status"></span>
              </a>
              <div class="dropdown-menu animated fadeIn" aria-labelledby="navbarDropdown">
                <div class="bg-gradient px-4 py-3">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="mr-1">
                      <h4 class="text-white mb-0">{{ $store.getters.getUser.first_name | capitalize }} {{ $store.getters.getUser.last_name | capitalize }}</h4>
                      <small class="text-white">{{ $store.getters.getUser.email }}</small>
                    </div>
                    <a
                      
                      class="text-white font-20 tooltip-wrapper"
                      data-toggle="tooltip"
                      data-placement="top"
                      title
                      data-original-title="Logout"
                      @click.prevent="logOut()"
                    >
                      <i class="zmdi zmdi-power"></i>
                    </a>
                  </div>
                </div>
                <div class="p-4">
                  <!-- <a class="dropdown-item d-flex nav-link" href="javascript:void(0)">
                    <i class="fa fa-user pr-2 text-success"></i> Profile
                  </a>
                  <a class="dropdown-item d-flex nav-link" href="javascript:void(0)">
                    <i class="fa fa-envelope pr-2 text-primary"></i> Inbox
                    <span class="badge badge-primary ml-auto">6</span>
                  </a>
                  <a class="dropdown-item d-flex nav-link" href="javascript:void(0)">
                    <i class="ti ti-settings pr-2 text-info"></i> Settings
                  </a>
                  <a class="dropdown-item d-flex nav-link" href="javascript:void(0)">
                    <i class="fa fa-compass pr-2 text-warning"></i> Need help?
                  </a> -->
                  <div class="row mt-2">
                    <!-- <div class="col">
                      <a class="bg-light p-3 text-center d-block">
                        <i class="fe fe-mail font-20 text-primary"></i>
                        <span class="d-block font-13 mt-2">My messages</span>
                      </a>
                    </div>
                    <div class="col">
                      <a class="bg-light p-3 text-center d-block">
                        <i class="fe fe-plus font-20 text-primary"></i>
                        <span class="d-block font-13 mt-2">Compose new</span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- end navigation -->
    </nav>
    <!-- end navbar -->
  </header>
  <!-- end app-header -->
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  methods: {
    logOut() {
      this.$store.dispatch('logOut');
      this.$router.push("/login");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
